import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessageService {
    private subject = new Subject<any>();
    private apiData = new Subject<any>();

    sendMessage(message) {
        this.subject.next(message);
    }

    clearMessages() {
        this.subject.next();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    sendApiData(data){
        this.apiData.next(data);
    }

    getApidata(): Observable<any>{
        return this.apiData.asObservable();
    }

    clearApiData(){
        this.apiData.next();
        this.apiData.complete();
    }
}